import { curry, type PlatformEvent } from 'lib/util'
import validate from 'lib/sequence/model/validate'
import reset from 'lib/sequence/model/api/reset'
import find from 'lib/sequence/component/children/find'
import focusFirstError from 'app/_shared/events/field/focusFirstError'

/**
 * Validate Organisation Step Event Handler
 *
 * @param module    the current module composition object
 * @param component the current action's main component
 * @param event     the event object that triggered this handler
 */
const validateOrganisationStep = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<boolean> => {
  const model = module[G.MODEL]
  const { organisation } = model[G.CHILDREN]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { organisationType, organisation: organisationForm } = find(actionComponent)

  reset(organisation)
  await validate(organisation)(organisationType)
  await validate(organisation)(organisationForm)

  focusFirstError(module, component, event)

  return !!organisation[G.STATE][G.ERROR]
}

export default curry(validateOrganisationStep)
